import { Checkbox, Size, Theme } from '@busybusy/webapp-react-ui';
import { SettingsIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { isNil } from 'lodash';
import * as React from 'react';
import { IDictionary } from 'types/Dictionary';
import { t } from 'utils/localize';
import { DashboardTimeType } from '../DashboardTimeSelect/DashboardTimeSelectFormField';
import './DashboardSettingsItem.scss';

export interface IDashboardSettingsItemProps {
  item: IDashboardSettingsItem;
  onCheckChange: (checked: boolean) => void;
  onSettingsIconClicked: (item: IDashboardSettingsItem) => void;
  className?: string | object;
}

export interface IDashboardSettingsItem {
  key: string;
  title: string;
  visible: boolean;
  position: number;
  customizable: boolean;
  options?: IDictionary<any>;
}

function DashboardSettingsItem(props: IDashboardSettingsItemProps) {
  const { item, onCheckChange, onSettingsIconClicked, className } = props;

  const handleSettingsAction = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onSettingsIconClicked(item);
  };

  function getOptionsText() {
    if (!isNil(item.options?.time)) {
      switch (item.options?.time) {
        case DashboardTimeType.PAST_7_DAYS:
          return t('Past 7 days');
        case DashboardTimeType.PAST_14_DAYS:
          return t('Past 14 days');
        case DashboardTimeType.WEEKLY:
          return t('Weekly');
        case DashboardTimeType.MONTHLY:
          return t('Monthly');
        case DashboardTimeType.PAY_PERIOD:
          return t('Pay Period');
        default:
          return t('Daily');
      }
    } else if (!isNil(item.options?.timeOffTimeFrame)) {
      switch (item.options?.timeOffTimeFrame) {
        case '7 days':
          return t('Next 7 days');
        case '30 days':
          return t('Next 30 days');
        default:
          return t('Upcoming');
      }
    }
    return '';
  }

  const classes = classNames('dashboard-settings-item py-2 ml-2', className);

  return (
    <div className={classes}>
      <Checkbox
        data-testid="settings_checkbox"
        className="checkbox-item"
        checked={item.visible}
        onChange={onCheckChange}
        label={item.title}
      />
      {getOptionsText()}

      {item.customizable && (
        <IconButton
          className="gears-icon"
          onClick={handleSettingsAction}
          svg={SettingsIcon}
          theme={Theme.LIGHT}
          buttonSize={Size.SMALL}
          tooltipLabel={t('Settings')}
        />
      )}
    </div>
  );
}

export default DashboardSettingsItem;
